import Index from '../views/TeamBoarding/Index'

let routes = {
    path: '/team-boarding',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/team-boarding',
            name: 'team-boarding',
            component: Index,
            meta: {
                pageTitle: 'menu.teamBoarding',
                access_nivel: ['1', '2', '3'],
                breadcrumb: [
                    {
                        text: 'teamBoarding.subtitle',
                        active: true,
                    },
                ],
            },
        },
    ],
}

export default routes
